import { HTMLAttributes, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

interface Props extends HTMLAttributes<HTMLDivElement> {
    children: ReactNode
}


export function Root({ children, ...rest }: Props) {
    return (
        <div 
            {...rest} 
            className={twMerge(
                "tw-flex tw-flex-col tw-px-20 tw-pt-10 tw-h-full tw-w-full tw-bg-white tw-rounded-[48px]",
                rest.className
            )}
        >
            {children}
        </div>
    )
}